/* LaReinaLabel — interactions (same behaviour as the approved design) */
(function(){
  const $ = s => document.querySelector(s);
  const toastEl = $("#toast"); let tt;
  function toast(m){ if(!toastEl) return; toastEl.textContent=m; toastEl.classList.add("show"); clearTimeout(tt); tt=setTimeout(()=>toastEl.classList.remove("show"),2200); }

  /* Links are set in Online Store → Themes → Customize → Theme settings → Links.
     Any link left empty shows a quiet note instead of leading nowhere. */
  document.querySelectorAll("[data-unset]").forEach(a=>a.addEventListener("click",e=>{ e.preventDefault(); toast("Link not connected yet"); }));

  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const finePointer = matchMedia("(hover:hover) and (pointer:fine)").matches;
  const clamp01=x=>Math.min(1,Math.max(0,x)), span=(p,a,b)=>clamp01((p-a)/(b-a)), ease=t=>1-Math.pow(1-t,3);

  function ready(v){ v.muted=true; v.playsInline=true; v.setAttribute("muted",""); v.setAttribute("playsinline",""); }

  /* hero film */
  const hv = document.querySelector(".plane video");
  if(hv){ ready(hv); hv.play().catch(()=>{}); }

  /* one reveal system for every piece of media + lazy video */
  const rio = new IntersectionObserver(es=>es.forEach(e=>{
    const el=e.target, v=el.querySelector("video");
    if(e.isIntersecting){ el.classList.add("in");
      if(v){ ready(v); if(!v.getAttribute("src") && v.dataset.src) v.src=v.dataset.src; if(v.getAttribute("src")) v.play().catch(()=>{}); } }
    else if(v) v.pause();
  }),{threshold:.15});
  document.querySelectorAll(".media,#ox,#shop").forEach(el=>rio.observe(el));

  /* mobile swipe indicator for the videos */
  const vrow=$("#vrow"), vd=[...document.querySelectorAll("#vdots i")];
  if(vrow && vd.length) vrow.addEventListener("scroll",()=>{ const kids=[...vrow.children], mid=vrow.scrollLeft+vrow.clientWidth/2;
    let best=0,bd=1e9; kids.forEach((k,i)=>{ const d=Math.abs(k.offsetLeft+k.offsetWidth/2-mid); if(d<bd){bd=d;best=i;} });
    vd.forEach((x,i)=>x.classList.toggle("on",i===best)); },{passive:true});

  const hdr=$("#hdr"), hero=$("#hero"), stage=$("#stage"), copy=$("#copy");

  /* pages without the hero: header is solid with the small wordmark showing */
  if(!hero || !stage || !copy){
    if(hdr){ hdr.classList.add("solid"); hdr.style.setProperty("--lo","1"); }
    return;
  }

  /* pointer depth: film and type sit on different planes */
  let mx=0,my=0;
  let ticking=false; const req=()=>{ if(!ticking){ ticking=true; requestAnimationFrame(frame); } };
  if(finePointer && !reduce){
    addEventListener("pointermove",e=>{ mx=e.clientX/innerWidth-.5; my=e.clientY/innerHeight-.5; req(); },{passive:true});
  }

  function frame(){
    ticking=false;
    const vh=innerHeight, vw=innerWidth, y=scrollY, mobile=vw<700;
    // the film recedes into the page as a tilted plate, ivory rises behind it
    const range=hero.offsetHeight-vh, p=clamp01(y/Math.max(1,range));
    const co=1-ease(span(p,0,.3)), rec=ease(span(p,.12,1));
    stage.style.setProperty("--co",co.toFixed(3));
    copy.style.setProperty("--co",co.toFixed(3));
    copy.classList.toggle("off",co<.2);
    stage.style.setProperty("--iv",rec.toFixed(3));
    if(!reduce){
      const endS = mobile ? .78 : .56;
      stage.style.setProperty("--s",(1-(1-endS)*rec).toFixed(4));
      stage.style.setProperty("--rx",(rec*7 + my*-2.4).toFixed(3)+"deg");
      stage.style.setProperty("--ry",(mx*3.2).toFixed(3)+"deg");
      stage.style.setProperty("--r",(rec*2).toFixed(1)+"px");
      copy.style.setProperty("--cx",(mx*-14).toFixed(1)+"px");
      copy.style.setProperty("--cy",(my*-10).toFixed(1)+"px");
    }
    if(hdr){ hdr.style.setProperty("--lo",(1-co).toFixed(3)); hdr.classList.toggle("solid", p>.55); }
  }
  addEventListener("scroll",req,{passive:true});
  addEventListener("resize",req);
  frame();
})();
